import axios from 'axios';
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
export const ADMIN_UNAUTHORIZED_EVENT = 'convertifile:admin-unauthorized';
// Remove the legacy bearer credential; the browser owns the HttpOnly cookie.
localStorage.removeItem('convertifile_admin_token');
export const api = axios.create({ baseURL: `${API_BASE_URL}/admin`, withCredentials: true, headers: { 'Content-Type': 'application/json' } });
let reauthenticate;
let pendingVerification;
export const setReauthenticationHandler = handler => { reauthenticate = handler; };
api.interceptors.response.use(response => response, async error => {
  const config = error.config;
  // The server rejects stale MFA before executing the mutation. Retry only that rejection once.
  if (error.response?.status === 403 && error.response?.data?.code === 'MFA_REQUIRED'
      && config && !config.mfaRetried && reauthenticate) {
    if (!pendingVerification) pendingVerification = Promise.resolve(reauthenticate()).finally(() => { pendingVerification = null; });
    if (await pendingVerification) return api.request({ ...config, mfaRetried: true });
  }
  if (!error.config?.skipUnauthorized && error.response?.status === 401 && !error.config?.url?.startsWith('/auth/')) window.dispatchEvent(new Event(ADMIN_UNAUTHORIZED_EVENT));
  return Promise.reject(error);
});
export const getErrorMessage = error => error.response?.data?.message || error.response?.data?.error || error.message || 'Request failed';
